
import useContacts from "./useContacts"
// Define interfaces for shared nested properties

const useGroundContact = () => {
    const { timelineContactData, planingContactData, selectedContact, setSelectedContact, contacts, configured_gs } = useContacts()

    return {
        contacts,
        configured_gs,
        planingContactData,
        timelineContactData,
        selectedContact,
        setSelectedContact,
    }
}

export default useGroundContact